@if (showNavigation()) {
  <ng-container
    *ngTemplateOutlet="enableA11yHeader ? a11yHeader : legacyHeader"
  />
}

<ng-template #a11yHeader>
  <ng-container
    *ngTemplateOutlet="showMainNavigation() ? mainNav : minimalNav"
  />
</ng-template>

<ng-template #legacyHeader>
  @if (loginUrl()) {
    <wl-skip-link [loginUrl]="loginUrl()" />
    @if (minimalNavigationActive()) {
      <wl-minimal-sticky-header-container />
    } @else {
      <wl-sticky-header-container />
    }
  }
</ng-template>

<ng-template #mainNav>
  <ng-container
    *ngTemplateOutlet="
      searchbarVisible()
        ? mainNavWhenSearchBarActive
        : mainNavWhenSearchBarInactive
    "
  />
</ng-template>

<ng-template #mainNavWhenSearchBarInactive>
  <wl-navigation-header>
    <wl-skip-link top [loginUrl]="loginUrl()" />

    <ng-container top *ngTemplateOutlet="topNavigationTemplate" />

    <wl-navigation-logo
      left
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />

    <wl-navigation-desktop
      class="d-none d-lg-block flex-shrink-0"
      left
      [navigationItems]="mainNavigation()?.navItems"
    />

    @if (enableSearch) {
      <!-- mobile -->
      <crnt-icon-button
        right
        class="d-lg-none"
        variant="tertiary"
        wlAutomationId="search-trigger-mobile"
        (click)="searchbarVisible.set(true)"
        #mobileSearchTriggerEl
      >
        <crnt-visually-hidden>Zoeken</crnt-visually-hidden>
        <crnt-icon icon="magnifying-glass" />
      </crnt-icon-button>
    }

    @if (enableSearch) {
      <!-- desktop -->
      <wl-search-trigger
        right
        class="d-none d-lg-block"
        (triggered)="searchbarVisible.set(true)"
        size="xl"
        #desktopSearchTriggerEl
      />
    }

    <wl-navigation-mobile
      class="d-lg-none"
      right
      [navigationItems]="mainNavigation()?.navItems"
      [domainNavigation]="topNavigation()?.navItems"
      [loginButton]="{
        url: loginUrl(),
        text: loginText(),
      }"
      openMenuButtonText="Open navigatie menu"
      closeMenuButtonText="Sluiten"
      menuTitle="Menu"
      position="end"
    />
  </wl-navigation-header>
</ng-template>

<ng-template #mainNavWhenSearchBarActive>
  <wl-navigation-header>
    <wl-skip-link top [loginUrl]="loginUrl()" />

    <ng-container top *ngTemplateOutlet="topNavigationTemplate" />

    <wl-navigation-logo
      left
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />

    <!-- mobile -->
    <div bottom class="d-lg-none mb-2">
      <div class="container">
        <wl-search-bar
          (removedFocus)="onSearchFocusRemoved()"
          [autofocus]="true"
        />
      </div>
    </div>

    <!-- desktop -->
    <div center class="d-none d-lg-block flex-grow-1 ms-2">
      <wl-search-bar
        (removedFocus)="onSearchFocusRemoved()"
        [autofocus]="true"
      />
    </div>

    <!-- mobile -->
    <crnt-button
      right
      class="d-lg-none"
      variant="secondary"
      (click)="searchbarVisible.set(false)"
    >
      Sluiten
      <crnt-icon slot="trailing" icon="xmark" />
    </crnt-button>
  </wl-navigation-header>
</ng-template>

<ng-template #minimalNav>
  <wl-navigation-header>
    <wl-skip-link top [loginUrl]="loginUrl()" [disableSkipToLogin]="true" />
    <wl-navigation-logo
      left
      [label]="logoLabel()"
      [url]="this.logoUrl() || '/'"
    />

    @if (showEcmpLogo()) {
      <wl-navigation-ecmp-logo
        left
        [src]="ecmpLogoSource()"
        [label]="ecmpLogo().description"
        [url]="ecmpLogo().url"
        [target]="ecmpLogo().target ?? '_blank'"
      />
    }
    @if (showMinimalNavigationHelp()) {
      <wl-navigation-help-needed-button
        right
        text="Hulp nodig?"
        (clicked)="dispatchHelpAction()"
      />
    }
  </wl-navigation-header>
</ng-template>

<ng-template #topNavigationTemplate>
  <div class="border-bottom d-none d-lg-block">
    <div
      class="d-flex justify-content-between align-items-center container py-1"
    >
      <wl-navigation-domain-links
        [navigationItems]="topNavigation()?.navItems"
      />
      @if (showLoginButton()) {
        <wl-navigation-service-button
          [href]="loginUrl()"
          iconName="user"
          [text]="loginText()"
        />
      }
    </div>
  </div>
</ng-template>
